import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { useLogin } from '@/modules/auth/presentation/hooks/use-login';
import { authContainer } from '@/modules/auth/di/container';
import logoAristoDark from '@/assets/image/logo-aristo-dark.svg';
import logoAristoLight from '@/assets/image/logo-aristo-light.png';
import logoFagDark from '@/assets/image/logo-fag-dark.png';
import logoFagLight from '@/assets/image/logo-fag-light.png';

export function Header() {
  const { institutionName, setShowLoginModal, setCourseId } =
    useInstitutionStore();
  const { openSwitcher } = useLogin();
  const isFag = institutionName?.toUpperCase() === 'FAG';

  const handleLogout = () => {
    if (institutionName) {
      authContainer.repository.clearToken(institutionName);
    }
    setCourseId(null);
    setShowLoginModal(true);
  };

  const handleSwitchList = () => {
    if (institutionName) {
      openSwitcher(institutionName);
    }
  };

  return (
    <header className="border-(--color-border) bg-(--color-bg-primary)/80 flex h-14 items-center justify-between border-b px-6 backdrop-blur-md md:fixed md:inset-x-0 md:top-0 md:z-50">
      <div className="flex items-center gap-3">
        <img src={logoAristoLight} alt="Aristo" className="h-6 dark:hidden" />
        <img
          src={logoAristoDark}
          alt="Aristo"
          className="hidden h-6 dark:block"
        />
        {isFag && (
          <>
            <span className="text-(--color-border) select-none">|</span>
            <img src={logoFagDark} alt="FAG" className="h-6 dark:hidden" />
            <img
              src={logoFagLight}
              alt="FAG"
              className="hidden h-6 dark:block"
            />
          </>
        )}
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={handleSwitchList}
          aria-label="Trocar turma"
          className="text-(--color-text-secondary) hover:bg-(--color-border)/50 hover:text-(--color-accent) rounded-lg p-2 transition-colors"
          title="Trocar turma"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
            />
          </svg>
        </button>

        <button
          onClick={handleLogout}
          aria-label="Sair"
          className="text-(--color-text-secondary) hover:bg-(--color-border)/50 rounded-lg p-2 transition-colors hover:text-red-400"
          title="Sair"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
            />
          </svg>
        </button>
      </div>
    </header>
  );
}
